// Define interfaces for the non-standard browser APIs
interface NavigatorWithMemory extends Navigator {
  deviceMemory?: number;
}

interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: {
    platform?: string;
    brands?: Array<{brand: string, version: string}>;
  };
}

// A simple fallback fingerprinting method that doesn't rely on external libraries
export const generateSimpleFingerprint = (): string => {
  const components = [
    navigator.userAgent,
    navigator.language,
    new Date().getTimezoneOffset(),
    screen.width + 'x' + screen.height + 'x' + screen.colorDepth,
    navigator.hardwareConcurrency,
    // Use type casting with proper interfaces instead of any
    (navigator as NavigatorWithMemory).deviceMemory || 'unknown',
    // Replace deprecated platform with userAgentData or fallback to userAgent
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform ||
      navigator.userAgent.split(/[()]/)[1] || 'unknown'
  ];

  // Create a simple hash from the components
  let hash = 0;
  const str = components.join('|||');

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  // Convert to a positive hex string
  return Math.abs(hash).toString(16);
};
